var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.4562.730957h-26.90924c-1.40868 0-2.54696 1.137203-2.54696 2.543753v25.45139c0 1.4023 1.13828 2.5427 2.54696 2.5427h26.90924c1.4023 0 2.5438-1.1393 2.5438-2.5427v-25.45139c-.0011-1.40655-1.1426-2.543753-2.5438-2.543753zm-7.9465 9.066663c-.6616-.3869-1.1864-.69258-1.8458-.69258-.6456 0-1.1971.16139-1.4793.43286-.2821.26934-.4221.7909-.4221 1.5615v1.1404h3.4511l-.7471 3.1723h-2.704v10.5405h-4.3351v-10.5405h-2.0233v-3.1723h2.0254v-1.2109c0-1.2751.1529-2.03823.4543-2.66775.3003-.62739.8828-1.32639 1.693-1.72184.809-.39439 2.0061-.59319 3.2448-.59319 1.2698 0 2.2616.42325 3.4779.7642z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e49805fdf79e1ee3187b6f2f81ea7042.svg";
export { ForwardRef as ReactComponent };